import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";


@Component({
    selector: 'page-previous-school-report',
    templateUrl: 'previous-school-report.html',
})
export class PreviousSchoolReportPage {

    School= 'GEIS';
    SchoolData = {};
    ReportData: any;
    AcademicYear: any;
    CountColumnData:any;
    AcademicYearTotalRow:any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public viewCtrl:ViewController,
                public service: ServiceProvider,
                public platform: Platform,
                public loadingCtrl: LoadingController,
                public storage: Storage) {
        this.platform.ready().then(() => {

            this.SchoolData = {
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };
            this.loadreport(this.SchoolData[this.School]);
        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad PreviousSchoolReportPage');
    }

    backBTN() {
        this.viewCtrl.dismiss();
    }

    active_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.loadreport(this.SchoolData[this.School]);
    }

    loadreport(SchoolId) {
        let loading = this.loadingCtrl.create({
            content: 'Loading',
            enableBackdropDismiss:true,
            spinner: 'bubbles',
        });
        loading.present();

        this.ReportData=null;
        this.AcademicYear=null;
        this.CountColumnData=null;
        this.AcademicYearTotalRow=null;
        this.service.httpcall('app_web_service/get_previos_school_admission_enquiry_report_by_schoolId?SchoolId=' + SchoolId).subscribe(data => {
            console.log('data', data);
            loading.dismiss();
            this.ReportData=data['table'];
            this.AcademicYear=data['AcademicYear'];
            this.CountColumnData=data['CountColumn'];
            this.AcademicYearTotalRow=data['AcademicYearTotalRow'];

        },error=>{
            loading.dismiss();
            this.service.showAlert("Timeout!", "Try again!");
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/previous-school-report/previous-school-report.ts